import { createComment as makeRequest } from "@/network/mutations/create-comment";
import { createServerFn } from "@tanstack/react-start";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  comment: v.string(),
  parent: v.optional(v.nullable(v.string())),
  name: v.string(),
  postId: v.number(),
  email: v.pipe(v.string(), v.nonEmpty(), v.email(), v.maxLength(128)),
});
export const createComment = createServerFn({ method: "POST" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema>) => v.parse(Schema, data))
  .handler(async ({ data }) => {
    const res = await makeRequest(data);
    return res;
  });
